<template>

  <div class="scrollable only-y">
    <resize-observer @notify="__resizeHandler"/>
    <el-tabs v-model="activeTab">
      <el-tab-pane name="InboundPlots" label="Inbound Activity" v-if="userIsReportsAdmin">
        <ActivityPlot
          ref="inboundPlot"
          v-observe-visibility="inboundVisibility"
          direction="IN"
          name="Inbound Activity"
          :branchOptions="branchOptions"
        />
      </el-tab-pane>
      <el-tab-pane name="OutboundActivity" label="Outbound Activity" v-if="userIsReportsAdmin">
        <ActivityPlot
          ref="outboundPlot"
          v-observe-visibility="outboundVisibility"
          direction="OUT"
          name="Outbound Activity"
          :branchOptions="branchOptions"
        />
      </el-tab-pane>
      <el-tab-pane name="CallRecords" label="Call Records">
        <CallRecordsTable
          ref="recordsTable"
          :branch-options="branchOptions"
        />
      </el-tab-pane>
    </el-tabs>
  </div>

</template>

<script>

  import ActivityPlot from './components/activity-plot';
  import CallRecordsTable from './components/call-records-table';
  import feathersClient from "@/feathers/feathers-client";
  import {phoneNumberFormatter} from "@/globals/globals";

  export default {
    name: 'CallSummary',
    components: {
      ActivityPlot,
      CallRecordsTable
    },
    data() {
      return {
        branchOptions: [],
        activeNavTab: null,
        resized: false
      }
    },
    methods: {
      queryBranches(){
        feathersClient.service('branches').find({
          query: {
            tenantId: this.selectedTenant.id
          }
        }).then( res => {
          this.branchOptions = res;
        }).catch(() => {
          this.branchOptions = [];
        });
      },
      outboundVisibility(isVisible, entry){
        if(isVisible){
          setTimeout(this.$refs.outboundPlot.buildChart(), 500);
        }
      },
      inboundVisibility(isVisible, entry){
        if(isVisible){
          setTimeout(this.$refs.inboundPlot.buildChart(), 500);
        }
      },
      numberFormatter(row, column) {
        return phoneNumberFormatter(row.number);
      },
      __resizeHandler: _.throttle(function (e) {
        if (this.resized) {
          setTimeout(() => {
            this.$refs.inboundPlot.chart.resize();
            this.$refs.outboundPlot.chart.resize();
          }, 1000)
        }
        this.resized = true;
      }, 700),
    },
    computed: {
      selectedTenant(){
        return this.$store.state.selectedTenant;
      },
      user(){
        return this.$store.state.auth.user;
      },
      userIsReportsAdmin(){
        const roles = [1,3,9,11,12];
        const { userRole, enableReporting } = this.user;
        return roles.includes(+userRole) || enableReporting;
      },
      activeTab: {
        get(){
          return this.userIsReportsAdmin ? 'InboundPlots' : 'CallRecords';
        },
        set(name){
          return name;
        }
      }
    },
    watch: {
      selectedTenant(){
        this.queryBranches();
      }
    },
    mounted() {
      //pass the branchs to the plots
      this.queryBranches();
    }
  }

</script>
